import { tv, type VariantProps } from "tailwind-variants";
import Root from "./typography.svelte";

const typographyVariants = tv({
  base: "font-medium",
  variants: {
    variant: {
      h1: "lg:text-[72x] text-[56px] leading-[4rem] font-[600] lg:leading-[80px] ",
      h2: "text-[46px] leading-[3.5rem] font-[600]",
      h3: "text-[30px] leading-10 font-[600]",
      h4: "text-[24px] leading-8 font-normal lg:font-medium",

      lead: "text-[20px] font-normal lg:font-medium leading-7", //Body 1
      large: "text-[16px]  font-normal lg:font-medium leading-6", //Body 2
      p: "text-[14px] font-normal lg:font-medium leading-5", //Body 3
      small: "text-[12px] font-normal lg:font-medium leading-4" //Body 4
    },
    color: {
      default: "text-theme-white",
      muted: "text-medium-gray",
      foreground: "text-primary-foreground",
      light_gray: "text-light-gray",
      destructive: "text-destructive",
      success: "text-success-green"
    },
    weight: {
      default: "",
      normal: "font-normal",
      bold: "font-bold",
      black: "font-black",
      semibold: "font-semibold",
      medium: "font-medium",
      light: "font-light",
      extralight: "font-extralight"
    },
    font: {
      default: "",
      poppins: "font-poppins"
    }
  },
  defaultVariants: {
    variant: "p",
    color: "default",
    weight: "default"
  }
});

export const variantAs: Record<NonNullable<Variant>, string> = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  p: "p",
  lead: "p",
  large: "div",
  small: "small"
};

export type Variant = VariantProps<typeof typographyVariants>["variant"];
export type Color = VariantProps<typeof typographyVariants>["color"];
export type Weight = VariantProps<typeof typographyVariants>["weight"];
export type Font = VariantProps<typeof typographyVariants>["font"];

type Props = {
  variant?: Variant;
  color?: Color;
  weight?: Weight;
  as?: string;
  class?: string;
  font?: Font;
};

export {
  Root,
  type Props,
  //
  Root as Typography,
  typographyVariants
};
